<template>
	<div>
		<div
			class="modal fade"
			id="downloadFile"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Download File</h5>
						<button type="button" class="close" data-dismiss="modal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body " style="margin-top:25px;margin-left:20px">
						<!-- <div><a id = "profile-a" target = "_blank" href="javascript:void(0)" @click="downloadProfile()">Download Profiles</a></div> -->
						<div id = "button-a"><a  href="javascript:void(0)" @click="downloadProfile()">Download Profiles</a></div>
						<div id = "button-b"><a href="javascript:void(0)" @click="downloadSeller()">Download Sellers</a></div>
						<div id = "button-c"><a href="javascript:void(0)" @click="downloadVendor()">Download Vendors</a></div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" >Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>


	import XLSX from "xlsx";

	export default {
		name: "DownloadFilesPopUp",
		data() {
			return {
				accountList:[],
				merchantList:[],
				vendorList:[]
			};
		},
		components: {},
		mounted(){
			let vm = this;
			let payload = {
				isPagination: false
			};
			this.$store.dispatch("accounts/getAccountListForDownload", payload).then(res => {
				this.accountList = res
			})

			this.$store.dispatch("accounts/getAllMerchant", payload).then(res => {
				this.merchantList = res
			})

			this.$store.dispatch("getAccountVendors", payload).then(res => {
				this.vendorList = res
			})

		},
		props: [],
		methods: {
			downloadProfile(){
					let data = [];
					let vm = this;
					this.accountList.forEach(resp => {
						let marketing_type = [];
						let profile_type = [];

						if (resp.marketing_campaign_sp) {
							marketing_type.push("SP");
						}
						if (resp.marketing_campaign_sb) {
							marketing_type.push("SB");
						}
						if (resp.marketing_campaign_sd) {
							marketing_type.push("SD");
						}
						if (resp.profile_type_seller) {
							profile_type.push("Seller");
						}
						if (resp.profile_type_vendor) {
							profile_type.push("Vendor");
						}
						var marketingType = marketing_type.join(",");
						var profileType = profile_type.join(",");
						let arr = {
							profile_id: resp.profile_id,
							client_name: resp.client_name,
							brand_name: resp.profile_brand_name,
							entity_id: resp.brand_entity_id,
							client_main_contact: resp.client_main_contact,
							// ara: resp.ara_type,
							marketing_type: marketingType,
							profile_type: profileType,
							go_retail: resp.go_retail_name,
							go_marketing: resp.go_marketing_name,
							go_ops: resp.go_ops_name,
							client_id:resp.client_id,
							client_name:resp.client_name
						};
						data.push(arr);
					});
					const wb = XLSX.utils.book_new();
					var workbook = XLSX.utils.json_to_sheet(data);
					//	let sheet = XLSX.utils.sheet_to_csv(workbook)
					XLSX.utils.book_append_sheet(
						wb,
						workbook,
						"excel_data.xlsx"
					);
					// var wbopts = {
					// 	type: "binary",
					// 	bookType: "xlsx"
					// };
					var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
					var blob = new Blob([vm.s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });

					let url = window.URL.createObjectURL(blob);
					var w = window.open(url)
					w.focus()
					//
					// var link = document.createElement('a');
					//   link.href = window.URL.createObjectURL(blob);
					//   link.target = '_blank'
					//   link.download = 'profile.xlsx';
					//   document.body.appendChild(link);
					//
					//   link.click();
					//
					//   document.body.removeChild(link);
					//var wbbuf = XLSX.writeFile(wb ,wbopts);
					// $("#button-a").click(function(){
					// 	   saveAs();
					// });
				//	this.$emit("fileImported");
			},
			downloadSeller(){
				let data = []
				let vm = this;
				this.merchantList.forEach(resp => {
					let arr = {
						vendor_name:resp.vendor_name,
						go_vendor_cd:resp.go_vendor_cd,
						ams_profile_id:resp.ams_profile_id,
						profile_brand_name:resp.profile_brand_name,
						merchant_id:resp.merchant_id,
						merchant_type:resp.merchant_type,
						country_code:resp.country_code,
						marketplace_id:resp.marketplace_id,
						marketplace_url:resp.marketplace_url,
						secret_access_key:resp.secret_access_key,
						seller_dev_auth_token:resp.seller_dev_auth_token,
						client_id:resp.go_client_id
					}
					data.push(arr);
				})
				const wb = XLSX.utils.book_new();
				var workbook = XLSX.utils.json_to_sheet(data);
				//	let sheet = XLSX.utils.sheet_to_csv(workbook)
				XLSX.utils.book_append_sheet(
					wb,
					workbook,
					"excel_data.xlsx"
				);
				// var wbopts = {
				// 	type: "base64",
				// 	bookType: "xlsx"
				// };

				var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
				var blob = new Blob([vm.s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
				let url = window.URL.createObjectURL(blob);
				var w = window.open(url)
				w.focus()

				// var link = document.createElement('a');
				//   link.href = window.URL.createObjectURL(blob);
				//   link.target = '_blank'
				//   link.download = 'seller.xlsx';
				//   document.body.appendChild(link);
				//
				//   link.click();
				//
				//   document.body.removeChild(link);
			//	XLSX.writeFile(wb, "account_management_seller_list.xlsx", wbopts);

			//	this.$emit("fileImported");


			},
			downloadVendor(){
				let data = [];
				let vm = this;
				this.vendorList.forEach(resp => {
					let arr = {
						vendor_name:resp.vendor_name,
						go_vendor_cd:resp.go_vendor_cd,
						vc_alias:resp.vc_alias,
						account_type:resp.account_type,
						client_id:resp.go_client_id
					}
					data.push(arr)
				})
				const wb = XLSX.utils.book_new();
				var workbook = XLSX.utils.json_to_sheet(data);
				//	let sheet = XLSX.utils.sheet_to_csv(workbook)
				XLSX.utils.book_append_sheet(
					wb,
					workbook,
					"excel_data.xlsx"
				);
				// var wbopts = {
				// 	type: "base64",
				// 	bookType: "xlsx"
				// };

				var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
				var blob = new Blob([vm.s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
				let url = window.URL.createObjectURL(blob);
				var w = window.open(url)
				w.focus()

				// var link = document.createElement('a');
				//   link.href = window.URL.createObjectURL(blob);
				//   link.target = '_blank'
				//   link.download = 'vendor.xlsx';
				//   document.body.appendChild(link);
				//
				//   link.click();
				//
				//   document.body.removeChild(link);

				// XLSX.writeFile(wb, "account_management_vendor_list.xlsx", wbopts);
				//this.$emit("fileImported");
			},
			s2ab(s) {
                var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
                var view = new Uint8Array(buf);  //create uint8array as viewer
                for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
                return buf;
			}
		}
	};
</script>

<style lang="scss">
</style>
